import {AfterViewInit, Component, OnDestroy} from '@angular/core';
import {ToastModel} from '@syncfusion/ej2-angular-notifications';
import {NotificationToastService} from '../../services/notification-toast.service';
import {Subscription} from 'rxjs';
import {ToastDetailedErrorModel} from '../../models/toasts/toast-detailed-error.model';
import {DatePipe} from '@angular/common';
import {toastAnim} from '../../animations/toast.animation';
import {fadeInOut} from '../../animations/fade-in-out.animation';


export const copyToClipboard = (value: any) => {
  const listener = (e) => {
    e.clipboardData.setData('text/plain', value);
    e.preventDefault();
    document.removeEventListener('copy', e);
  };
  document.addEventListener('copy', listener);
  document.execCommand('copy');
};

@Component({
  selector: 'app-notification-toast',
  templateUrl: './notification-toast.component.html',
  styleUrls: ['./notification-toast.component.scss'],
  animations: [toastAnim, fadeInOut],
  providers: [DatePipe]
})
export class NotificationToastComponent implements AfterViewInit, OnDestroy {
  private subscription: Subscription;
  toasts: ToastModel[] = [];
  clipBoardCopyVisible = [];
  timeOutInfos: {toast: ToastModel, timeoutHandle: number}[] = [];

  public readonly position = {X: 'Right', Y: 'Bottom'};
  public readonly showAnimation = {
    show: {effect: 'SlideBottomIn'},
    hide: {effect: 'FadeOut'},
  };
  isToastVisible = false;

  constructor(private notificationToastService: NotificationToastService, private datePipe: DatePipe) {}

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngAfterViewInit(): void {
    this.subscription = this.notificationToastService.notificationToastEvent.subscribe(toast => {
      if (toast != null) {
        const timeout = toast.timeOut || 5000;
        this.toasts.push(toast);
        if (!this.isToastWithDetails(toast)) {
          this.timeOutInfos.push({toast, timeoutHandle: setTimeout(() => {
            const idx = this.timeOutInfos.findIndex(it => it.toast == toast);
            if (idx >= 0) {
              this.timeOutInfos.splice(idx, 1);
            }
            this.fermerToast(toast);
          }, timeout)});
        }
      }
    });
  }

  cancelTimeout(toast: ToastModel) {
    const handle = this.timeOutInfos.find(it => it.toast == toast);
    if (handle != null) {
      clearTimeout(handle.timeoutHandle);
      this.timeOutInfos.splice(this.timeOutInfos.indexOf(handle), 1)
    }
  }

  private formatTimeStamp(date: Date) {
    return this.datePipe.transform(date, 'yyyy-MM-dd hh:mm:ss.SS')
  }

  private formatClipboardInfo(toastDetaille: ToastDetailedErrorModel) {
    const err = toastDetaille.details;
    const details = err.details;
    const formatedTimestamp = this.formatTimeStamp(details.timestamp);
    return `Message : ${details.message}
-------------------------------------
Microservice : ${details.microservice}
Timestamp : ${formatedTimestamp}
User ID : ${details.idUtilisateur}
Client ID : ${details.idClient}
-------------------------------------
Stacktrace : \n ${details.stacktrace}`
  }

  copyToClipboard(toast: ToastModel) {
    const infos = this.formatClipboardInfo(toast as ToastDetailedErrorModel);
    copyToClipboard(infos);
    this.clipBoardCopyVisible.push(toast);
    setTimeout(() => {
      this.clipBoardCopyVisible.splice(this.clipBoardCopyVisible.indexOf(toast), 1)
    }, 2000 );
  }

  isToastWithDetails(toast: ToastModel) {
    return toast instanceof ToastDetailedErrorModel
  }

  hasButtons(toast: ToastModel) {
    return this.isToastWithDetails(toast)
  }

  fermerToast(toast: ToastModel) {
    this.toasts.splice(this.toasts.indexOf(toast), 1);
  }

  isCopyOnClipboard(toast: ToastModel) {
    return this.clipBoardCopyVisible.find(it => it == toast) != null;
  }

  close(toast: ToastModel) {
    if (!this.isToastWithDetails(toast)) {
      this.fermerToast(toast);
    }
  }

  hasTitle(toast: ToastModel) {
    return toast.title != null && toast.title != '';
  }

  restartTimeout(toast: ToastModel) {
    if (!this.isToastWithDetails(toast)) {
      const handle = setTimeout(() => {
        const idx = this.timeOutInfos.findIndex(it => it.toast == toast);
        if (idx >= 0) {
          this.timeOutInfos.splice(idx, 1);
        }
        this.fermerToast(toast);
      }, 2000);
      this.timeOutInfos.push({toast, timeoutHandle: handle});
    }
  }
}
